import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import Sidebar from "../../partials/aside/Sidebar";
import httpService from "../../../services/httpServices/httpServices";
import helperNumber from "../../../helpers/numbers";
import validtionAnswerTicket from "../../../validtions/forms/ticket/answer-ticket";
import messagesTicket from "../../../messages/ticket";
import helperSpinner from "../../../helpers/spinner";

function AnswerTicket() {
  const [tagFileAttachment, setTagFileAttachment] = useState([]);
  const [tagRepliesTicket, setTagRepliesTicket] = useState([]);
  const [ticketData, setTicketData] = useState();
  const [message, setMessage] = useState();
  const history = useHistory();
  let userName;

  let stateTickets;

  let messageTag;

  if (message) {
    messageTag = (
      <div className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }
  const params = useParams();
  const ticketID = params.id;

  useEffect(() => {
    getTicketData();
  }, []);

  const getTicketData = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const ticketData = await sendRequestGetTicketData();
    userName = ticketData.user_name;

    stateTickets = await sendRequestGetStatusTicket();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    setTicketData(generateTicketData(ticketData));

    let allTagRepliesTicket = [];
    ticketData.replies.forEach((reply, index) => {
      allTagRepliesTicket = [
        ...allTagRepliesTicket,
        generateTicketReplies(reply, index),
      ];
    });

    setTagRepliesTicket(allTagRepliesTicket);
  };

  const getHeaderForRequset = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const sendRequestGetTicketData = async () => {
    const headersRequest = getHeaderForRequset();
    let ticketData;
    try {
      ticketData = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/ticket/view-supporter-ticket/" +
          ticketID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return ticketData.data.data;
  };

  const AddTicketAttachment = () => {
    const tagsExampleTicketAttachment = (
      <div className="py-2">
        <input
          type="file"
          name="file"
          accept=".png, .jpeg,.jpg,.plain, .pdf,.doc, .docx"
          className="form-control"
        />
      </div>
    );

    setTagFileAttachment([...tagFileAttachment, tagsExampleTicketAttachment]);
  };

  const generateTicketData = (ticketData) => {
    let tagOptionsSelect;

    tagOptionsSelect = Object.keys(stateTickets).map(function (key, value) {
      let selected = "";

      if (stateTickets[key] === ticketData.status) {
        selected = "selected";
      }
      return (
        <option value={key} selected={selected}>
          {stateTickets[key]}
        </option>
      );
    });

    const generateTagTicketData = (
      <>
        <div className="text-center pt-2">
          <span className="px-2">
            <span> عنوان تیکت : </span>
            <span className="text-danger">{ticketData.title} </span>
          </span>
          <span className="px-2">
            <span> دسته : </span>
            <p className="d-inline-block">{ticketData.category}</p>
          </span>
          <span className="px-2">
            <span>وضعیت تیکت :</span>
            {setBageForStatus(ticketData.status)}
          </span>
        </div>
        <div className="d-flex pr-4">
          <div>
            <select id="status-ticket" className="form-control">
              {tagOptionsSelect}
            </select>
          </div>
          <div className="pr-2">
            <span className="btn btn-info " onClick={setStatusTicket}>
              اعمال وضعیت
            </span>
          </div>
        </div>
      </>
    );

    return generateTagTicketData;
  };

  const generateTicketFile = (files) => {
    let tagsFile = files.map((file, index) => {
      let fileUrl =
        process.env.REACT_APP_DOMAIN_API +
        "/" +
        process.env.REACT_APP_URL_TICKET_FILES +
        "/" +
        file;
      return (
        <div className="pl-2">
          <a className="btn btn-secondary " target="_blank" href={fileUrl}>
            <span className="pl-2">
              <i className="fa fa-file"></i>
            </span>
            <span>
              <span>فایل</span>
              <span className="pr-2">
                {helperNumber.toPersianNum(index + 1)}
              </span>
            </span>
          </a>
        </div>
      );
    });

    return tagsFile;
  };

  const generateTicketReplies = (reply, index) => {
    let tagsFile = "";
    if (reply.files) {
      tagsFile = generateTicketFile(reply.files);
    }

    let text = reply.text.split("\n").map((i) => {
      return <p>{i}</p>;
    });

    let classHeaderBg;
    if (userName == reply.user_name) {
      classHeaderBg = "bg-danger";
    } else {
      classHeaderBg = "bg-primary";
    }
    return (
      <div key={index} className="card">
        <div className={`card-header ${classHeaderBg} `}>
          <div className="d-flex justify-content-between">
            <div className="d-flex">
              <div className="pl-2">
                <i className="fa fa-user"></i>
              </div>
              <div>{reply.user_name}</div>
            </div>
            <div className="d-inline-block">
              {helperNumber.toPersianNum(reply.createdAt)}
            </div>
          </div>
        </div>
        <div className="card-body text-justify">{text}</div>
        <div className="card-footer">
          <div className="d-flex align-items-center ">
            <div className="pl-2"> فایل های آپلود شده: </div>
            <div className="d-flex">{tagsFile}</div>
          </div>
        </div>
      </div>
    );
  };

  const setBageForStatus = (statusTitle) => {
    let tagBage;

    switch (statusTitle) {
      case messagesTicket.TICKET_STATE_PENDING:
        tagBage = <span className="badge  badge-warning">{statusTitle}</span>;
        break;
      case messagesTicket.TICKET_STATE_ANSWERED:
        tagBage = <span className="badge  badge-info">{statusTitle}</span>;
        break;
      case messagesTicket.TICKET_STATE_CLOSED:
        tagBage = <span className="badge  badge-success">{statusTitle}</span>;
        break;
    }

    return tagBage;
  };

  const sendRequestGetStatusTicket = async () => {
    const headersRequest = getHeaderForRequset();
    let allStatusTicket;
    try {
      allStatusTicket = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/ticket/get-status",
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return;
    }
    return allStatusTicket.data.data;
  };

  const sendForm = async (event) => {
    event.preventDefault();

    const data = getDataForm();

    if (!data) {
      return;
    }
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (await sendRequestAnswerTicket(data)) {
      history.push("/ticket/all");
      return;
    }
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
  };

  const sendRequestAnswerTicket = async (data) => {
    const headersRequest = getHeaderForRequset();

    try {
      await httpService.postRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/ticket/answer-supporter-ticket/" +
          ticketID,
        data,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return;
    }

    return true;
  };

  const getDataForm = () => {
    let data = getFilesInput();

    let text = document.getElementById("text").value;

    const dataInputs = {
      text: text,
    };
    if (validtionAnswerTicket(dataInputs) != true) {
      setMessage({
        type_class: "alert alert-danger",
        text: validtionAnswerTicket(dataInputs),
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }

    data.append("text", text);

    return data;
  };

  const getFilesInput = () => {
    const countFilesInpit = tagFileAttachment.length;
    const filesInput = document.getElementsByName("file");

    let data = new FormData();

    let j = 1;
    for (let i = 0; i < countFilesInpit + 1; i++) {
      if (filesInput[i].files[0]) {
        data.append("file-" + j, filesInput[i].files[0]);
        j++;
      }
    }
    return data;
  };

  const setStatusTicket = () => {
    const statusTicketTag = document.getElementById("status-ticket");
    let valueStateTicket =
      statusTicketTag.options[statusTicketTag.selectedIndex].value;
    const data = {
      status: valueStateTicket,
    };

    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (sendRequestChangeStateTicket(data)) {
      history.push("/ticket/all");
      return;
    }
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
  };

  const sendRequestChangeStateTicket = async (data) => {
    const headersRequest = getHeaderForRequset();

    try {
      await httpService.putRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/ticket/change-status/" +
          ticketID,
        data,
        headersRequest
      );
      return true;
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
  };

  return (
    <>
      <Sidebar openItem="tickets" />
      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">پاسخ به تیکت کاربر</h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            {ticketData}

            <div className="card-body">
              {messageTag}
              <div className="card">
                <div
                  className="card-header bg-success hover"
                  data-toggle="collapse"
                  data-target="#collapseOne"
                  aria-expanded="true"
                  aria-controls="collapseOne"
                >
                  <div className="d-flex justify-content-between">
                    <div className="d-flex">
                      <div className="pl-2">
                        <i className="fa fa-check"></i>
                      </div>
                      <div>پاسخ</div>
                    </div>
                  </div>
                </div>
                <form encType="multipart/form-data" onSubmit={sendForm}>
                  <div
                    id="collapseOne"
                    className="collapse show "
                    aria-labelledby="headingOne"
                    data-parent="#accordion"
                  >
                    <div className="card-body">
                      <div className="form-group">
                        <label>متن</label>
                        <textarea
                          className="form-control"
                          id="text"
                          rows="10"
                          name="text"
                        ></textarea>
                      </div>
                      <input
                        type="submit"
                        className="btn btn-primary"
                        value="ارسال"
                      />
                    </div>
                    <div className="card-footer">
                      <div className="row form-group">
                        <div className="col-sm-3 col-sm-push-9">
                          <button
                            type="button"
                            className="btn btn-default btn-block"
                            onClick={AddTicketAttachment}
                          >
                            <i className="fa fa-plus"></i> افزودن موارد دیگر
                          </button>
                        </div>
                        <div className="col-sm-9 col-sm-pull-3">
                          <input
                            type="file"
                            name="file"
                            accept=".png, .jpeg,.jpg,.plain, .pdf,.doc, .docx"
                            className="form-control"
                          />
                          <div id="fileUploadsContainer">
                            {tagFileAttachment}
                          </div>
                        </div>
                        <div className="col-xs-12 ticket-attachments-message text-muted">
                          پسوند های مجاز: jpg, .jpeg, .png, .txt, .doc
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              {tagRepliesTicket}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default AnswerTicket;
